const translationKeys = {
  epk_flex_onboarding_header_text: 'epk_flex_onboarding_header_text',
  epk_flex_onboarding_eligibility_step_explanation_info_1:
    'epk_flex_onboarding_eligibility_step_explanation_info_1',
  epk_flex_onboarding_eligibility_step_explanation_title:
    'epk_flex_onboarding_eligibility_step_explanation_title',
  epk_flex_onboarding_eligibility_step_explanation_read_more_link:
    'epk_flex_onboarding_eligibility_step_explanation_read_more_link',
  epk_flex_onboarding_eligibility_step_criteria_title:
    'epk_flex_onboarding_eligibility_step_criteria_title',
  epk_flex_onboarding_eligibility_step_criteria_info:
    'epk_flex_onboarding_eligibility_step_criteria_info',
  epk_flex_onboarding_eligibility_step_criteria_group_title:
    'epk_flex_onboarding_eligibility_step_criteria_group_title',
  epk_flex_onboarding_eligibility_step_criteria_group_rule_2:
    'epk_flex_onboarding_eligibility_step_criteria_group_rule_2',
  epk_flex_onboarding_eligibility_step_criteria_group_rule_3:
    'epk_flex_onboarding_eligibility_step_criteria_group_rule_3',
  epk_flex_onboarding_eligibility_step_comparison_title:
    'epk_flex_onboarding_eligibility_step_comparison_title',
  epk_flex_onboarding_eligibility_step_comparison_table_header_account:
    'epk_flex_onboarding_eligibility_step_comparison_table_header_account',
  epk_flex_onboarding_eligibility_step_comparison_table_header_flex:
    'epk_flex_onboarding_eligibility_step_comparison_table_header_flex',
  epk_flex_onboarding_eligibility_step_comparison_table_employer_saves:
    'epk_flex_onboarding_eligibility_step_comparison_table_employer_saves',
  epk_flex_onboarding_eligibility_step_comparison_table_money_locked_until:
    'epk_flex_onboarding_eligibility_step_comparison_table_money_locked_until',
  epk_flex_onboarding_eligibility_step_comparison_table_employment_relationship:
    'epk_flex_onboarding_eligibility_step_comparison_table_employment_relationship',
  epk_flex_onboarding_eligibility_step_comparison_table_previously_saved:
    'epk_flex_onboarding_eligibility_step_comparison_table_previously_saved',
  epk_flex_onboarding_eligibility_step_comparison_table_compensated:
    'epk_flex_onboarding_eligibility_step_comparison_table_compensated',
  epk_flex_onboarding_eligibility_step_comparison_table_pension_profiles:
    'epk_flex_onboarding_eligibility_step_comparison_table_pension_profiles',
  epk_flex_onboarding_eligibility_step_comparison_table_invest_freely:
    'epk_flex_onboarding_eligibility_step_comparison_table_invest_freely',
  epk_flex_onboarding_eligibility_step_costs_title:
    'epk_flex_onboarding_eligibility_step_costs_title',
  epk_flex_onboarding_eligibility_step_costs_info_1:
    'epk_flex_onboarding_eligibility_step_costs_info_1',
  epk_flex_onboarding_eligibility_step_costs_link_price_list:
    'epk_flex_onboarding_eligibility_step_costs_link_price_list',
  epk_flex_onboarding_eligibility_step_costs_bottom_info:
    'epk_flex_onboarding_eligibility_step_costs_bottom_info',
  epk_flex_onboarding_eligibility_step_check_title:
    'epk_flex_onboarding_eligibility_step_check_title',
  epk_flex_onboarding_eligibility_step_check_info:
    'epk_flex_onboarding_eligibility_step_check_info',
  epk_flex_onboarding_eligibility_step_check_info_button_approve:
    'epk_flex_onboarding_eligibility_step_check_info_button_approve',
  epk_flex_onboarding_eligibility_step_check_info_button_return:
    'epk_flex_onboarding_eligibility_step_check_info_button_return',
  epk_flex_skeleton_loading_text: 'epk_flex_skeleton_loading_text',
  epk_flex_onboarding_check_loader_text:
    'epk_flex_onboarding_check_loader_text',
  epk_flex_onboarding_eligibility_check_ineligible_back_button_text:
    'epk_flex_onboarding_eligibility_check_ineligible_back_button_text',
  epk_flex_onboarding_eligibility_check_eligible_success_text:
    'epk_flex_onboarding_eligibility_check_eligible_success_text',
  epk_flex_onboarding_eligibility_check_eligible_info_title:
    'epk_flex_onboarding_eligibility_check_eligible_info_title',
  epk_flex_onboarding_eligibility_check_eligible_info_item_1:
    'epk_flex_onboarding_eligibility_check_eligible_info_item_1',
  epk_flex_onboarding_eligibility_check_eligible_info_item_2:
    'epk_flex_onboarding_eligibility_check_eligible_info_item_2',
  epk_flex_onboarding_eligibility_check_eligible_info_continue_button_text:
    'epk_flex_onboarding_eligibility_check_eligible_info_continue_button_text',
  epk_flex_onboarding_eligibility_risk_info_title:
    'epk_flex_onboarding_eligibility_risk_info_title',
  epk_flex_onboarding_eligibility_risk_info_text:
    'epk_flex_onboarding_eligibility_risk_info_text',
  epk_flex_onboarding_eligibility_risk_back_button_text:
    'epk_flex_onboarding_eligibility_risk_back_button_text',
  epk_flex_onboarding_eligibility_risk_next_button_text:
    'epk_flex_onboarding_eligibility_risk_next_button_text',
  epk_flex_onboarding_eligibility_risk_questionnaire_step_one_title:
    'epk_flex_onboarding_eligibility_risk_questionnaire_step_one_title',
  epk_flex_onboarding_eligibility_risk_questionnaire_step_two_title:
    'epk_flex_onboarding_eligibility_risk_questionnaire_step_two_title',
  epk_flex_onboarding_eligibility_risk_questionnaire_step_three_title:
    'epk_flex_onboarding_eligibility_risk_questionnaire_step_three_title',
  epk_flex_onboarding_eligibility_risk_questionnaire_step_one_question_title:
    'epk_flex_onboarding_eligibility_risk_questionnaire_step_one_question_title',
  epk_flex_onboarding_eligibility_risk_questionnaire_step_one_question_text:
    'epk_flex_onboarding_eligibility_risk_questionnaire_step_one_question_text',
  epk_flex_onboarding_eligibility_risk_questionnaire_step_one_question_option_text:
    'epk_flex_onboarding_eligibility_risk_questionnaire_step_one_question_option_text',
  epk_flex_onboarding_eligibility_risk_questionnaire_step_one_next_button_text:
    'epk_flex_onboarding_eligibility_risk_questionnaire_step_one_next_button_text',
  epk_flex_onboarding_eligibility_risk_questionnaire_step_two_question_title:
    'epk_flex_onboarding_eligibility_risk_questionnaire_step_two_question_title',
  epk_flex_onboarding_eligibility_risk_questionnaire_step_two_question_text:
    'epk_flex_onboarding_eligibility_risk_questionnaire_step_two_question_text',
  epk_flex_onboarding_eligibility_risk_questionnaire_step_two_question_info_message:
    'epk_flex_onboarding_eligibility_risk_questionnaire_step_two_question_info_message',
  epk_flex_onboarding_eligibility_risk_questionnaire_step_two_fluctuations_very_small:
    'epk_flex_onboarding_eligibility_risk_questionnaire_step_two_fluctuations_very_small',
  epk_flex_onboarding_eligibility_risk_questionnaire_step_two_fluctuations_small:
    'epk_flex_onboarding_eligibility_risk_questionnaire_step_two_fluctuations_small',
  epk_flex_onboarding_eligibility_risk_questionnaire_step_two_fluctuations_some:
    'epk_flex_onboarding_eligibility_risk_questionnaire_step_two_fluctuations_some',
  epk_flex_onboarding_eligibility_risk_questionnaire_step_two_fluctuations_big:
    'epk_flex_onboarding_eligibility_risk_questionnaire_step_two_fluctuations_big',
  epk_flex_onboarding_eligibility_risk_questionnaire_step_two_fluctuations_very_big:
    'epk_flex_onboarding_eligibility_risk_questionnaire_step_two_fluctuations_very_big',
  epk_flex_onboarding_eligibility_risk_questionnaire_step_two_fluctuations_value:
    'epk_flex_onboarding_eligibility_risk_questionnaire_step_two_fluctuations_value',
  epk_flex_onboarding_eligibility_risk_questionnaire_step_two_market_decline_info_text:
    'epk_flex_onboarding_eligibility_risk_questionnaire_step_two_market_decline_info_text',
  epk_flex_onboarding_eligibility_risk_questionnaire_step_two_market_decline_question_title:
    'epk_flex_onboarding_eligibility_risk_questionnaire_step_two_market_decline_question_title',
  epk_flex_onboarding_eligibility_risk_questionnaire_step_two_market_decline_question_text:
    'epk_flex_onboarding_eligibility_risk_questionnaire_step_two_market_decline_question_text',
  epk_flex_onboarding_eligibility_risk_questionnaire_step_two_market_decline_answer_yes:
    'epk_flex_onboarding_eligibility_risk_questionnaire_step_two_market_decline_answer_yes',
  epk_flex_onboarding_eligibility_risk_questionnaire_step_two_market_decline_answer_no:
    'epk_flex_onboarding_eligibility_risk_questionnaire_step_two_market_decline_answer_no',
  epk_flex_onboarding_eligibility_risk_questionnaire_step_two_market_decline_answer_tip_text:
    'epk_flex_onboarding_eligibility_risk_questionnaire_step_two_market_decline_answer_tip_text',
  epk_flex_onboarding_eligibility_risk_questionnaire_step_three_risk_profile_title:
    'epk_flex_onboarding_eligibility_risk_questionnaire_step_three_risk_profile_title',
  epk_flex_onboarding_eligibility_risk_questionnaire_step_three_risk_profile_careful_title:
    'epk_flex_onboarding_eligibility_risk_questionnaire_step_three_risk_profile_careful_title',
  epk_flex_onboarding_eligibility_risk_questionnaire_step_three_risk_profile_careful_text:
    'epk_flex_onboarding_eligibility_risk_questionnaire_step_three_risk_profile_careful_text',
  epk_flex_onboarding_eligibility_risk_questionnaire_step_three_risk_profile_moderate_title:
    'epk_flex_onboarding_eligibility_risk_questionnaire_step_three_risk_profile_moderate_title',
  epk_flex_onboarding_eligibility_risk_questionnaire_step_three_risk_profile_moderate_text:
    'epk_flex_onboarding_eligibility_risk_questionnaire_step_three_risk_profile_moderate_text',
  epk_flex_onboarding_eligibility_risk_questionnaire_step_three_risk_profile_offensive_title:
    'epk_flex_onboarding_eligibility_risk_questionnaire_step_three_risk_profile_offensive_title',
  epk_flex_onboarding_eligibility_risk_questionnaire_step_three_risk_profile_offensive_text:
    'epk_flex_onboarding_eligibility_risk_questionnaire_step_three_risk_profile_offensive_text',
  epk_flex_onboarding_eligibility_risk_questionnaire_step_three_risk_profile_allocation_interest_label:
    'epk_flex_onboarding_eligibility_risk_questionnaire_step_three_risk_profile_allocation_interest_label',
  epk_flex_onboarding_eligibility_risk_questionnaire_step_three_risk_profile_allocation_stock_label:
    'epk_flex_onboarding_eligibility_risk_questionnaire_step_three_risk_profile_allocation_stock_label',
  epk_flex_onboarding_profile_options_title:
    'epk_flex_onboarding_profile_options_title',
  epk_flex_onboarding_profile_options_pension_profile_title:
    'epk_flex_onboarding_profile_options_pension_profile_title',
  epk_flex_onboarding_profile_options_fund_profile_title:
    'epk_flex_onboarding_profile_options_fund_profile_title',
  epk_flex_onboarding_profile_options_pension_profile_text:
    'epk_flex_onboarding_profile_options_pension_profile_text',
  epk_flex_onboarding_profile_options_pension_profile_button:
    'epk_flex_onboarding_profile_options_pension_profile_button',
  epk_flex_onboarding_profile_options_fund_profile_text:
    'epk_flex_onboarding_profile_options_fund_profile_text',
  epk_flex_onboarding_profile_options_fund_profile_button:
    'epk_flex_onboarding_profile_options_fund_profile_button',
  epk_flex_onboarding_confirm_fund_portfolio_title:
    'epk_flex_onboarding_confirm_fund_portfolio_title',
  epk_flex_onboarding_confirm_fund_portfolio_subtitle:
    'epk_flex_onboarding_confirm_fund_portfolio_subtitle',
  epk_flex_onboarding_confirm_fund_portfolio_items_title:
    'epk_flex_onboarding_confirm_fund_portfolio_items_title',
  epk_flex_onboarding_confirm_fund_portfolio_item_1:
    'epk_flex_onboarding_confirm_fund_portfolio_item_1',
  epk_flex_onboarding_confirm_fund_portfolio_item_2:
    'epk_flex_onboarding_confirm_fund_portfolio_item_2',
  epk_flex_onboarding_confirm_fund_portfolio_item_3:
    'epk_flex_onboarding_confirm_fund_portfolio_item_3',
  epk_flex_onboarding_confirm_fund_portfolio_item_4:
    'epk_flex_onboarding_confirm_fund_portfolio_item_4',
  epk_flex_onboarding_confirm_fund_portfolio_item_5:
    'epk_flex_onboarding_confirm_fund_portfolio_item_5',
  epk_flex_onboarding_confirm_fund_portfolio_checkbox:
    'epk_flex_onboarding_confirm_fund_portfolio_checkbox',
  epk_flex_onboarding_confirm_fund_portfolio_back_button:
    'epk_flex_onboarding_confirm_fund_portfolio_back_button',
  epk_flex_onboarding_confirm_fund_portfolio_start_button:
    'epk_flex_onboarding_confirm_fund_portfolio_start_button',
  epk_flex_onboarding_funds_filter_select_regions_step_title:
    'epk_flex_onboarding_funds_filter_select_regions_step_title',
  epk_flex_onboarding_funds_filter_select_risk_levels_step_title:
    'epk_flex_onboarding_funds_filter_select_risk_levels_step_title',
  epk_flex_onboarding_funds_filter_select_funds_step_title:
    'epk_flex_onboarding_funds_filter_select_funds_step_title',
  epk_flex_onboarding_funds_filter_back_button:
    'epk_flex_onboarding_funds_filter_back_button',
  epk_flex_onboarding_funds_filter_next_button:
    'epk_flex_onboarding_funds_filter_next_button',
  epk_flex_onboarding_funds_filter_select_all_button:
    'epk_flex_onboarding_funds_filter_select_all_button',
  epk_flex_onboarding_funds_filter_select_button:
    'epk_flex_onboarding_funds_filter_select_button',
  epk_flex_onboarding_funds_filter_region_item_america:
    'epk_flex_onboarding_funds_filter_region_item_america',
  epk_flex_onboarding_funds_filter_region_item_asia:
    'epk_flex_onboarding_funds_filter_region_item_asia',
  epk_flex_onboarding_funds_filter_region_item_europe:
    'epk_flex_onboarding_funds_filter_region_item_europe',
  epk_flex_onboarding_funds_filter_region_item_nordics:
    'epk_flex_onboarding_funds_filter_region_item_nordics',
  epk_flex_onboarding_funds_filter_region_item_global:
    'epk_flex_onboarding_funds_filter_region_item_global',
  epk_flex_onboarding_funds_filter_region_item_norway:
    'epk_flex_onboarding_funds_filter_region_item_norway',
  epk_flex_onboarding_funds_filter_region_title:
    'epk_flex_onboarding_funds_filter_region_title',
  epk_flex_onboarding_funds_filter_risk_title:
    'epk_flex_onboarding_funds_filter_risk_title',
  epk_flex_onboarding_funds_filter_risk_item_low:
    'epk_flex_onboarding_funds_filter_risk_item_low',
  epk_flex_onboarding_funds_filter_risk_item_medium:
    'epk_flex_onboarding_funds_filter_risk_item_medium',
  epk_flex_onboarding_funds_filter_risk_item_high:
    'epk_flex_onboarding_funds_filter_risk_item_high',
  epk_flex_onboarding_funds_filter_risk_more_info_button:
    'epk_flex_onboarding_funds_filter_risk_more_info_button',
  epk_flex_onboarding_funds_filter_risk_more_info_page_title:
    'epk_flex_onboarding_funds_filter_risk_more_info_page_title',
  epk_flex_onboarding_funds_filter_risk_more_info_low_risk:
    'epk_flex_onboarding_funds_filter_risk_more_info_low_risk',
  epk_flex_onboarding_funds_filter_risk_more_info_low_risk_text:
    'epk_flex_onboarding_funds_filter_risk_more_info_low_risk_text',
  epk_flex_onboarding_funds_filter_risk_more_info_medium_risk:
    'epk_flex_onboarding_funds_filter_risk_more_info_medium_risk',
  epk_flex_onboarding_funds_filter_risk_more_info_medium_risk_text:
    'epk_flex_onboarding_funds_filter_risk_more_info_medium_risk_text',
  epk_flex_onboarding_funds_filter_risk_more_info_high_risk:
    'epk_flex_onboarding_funds_filter_risk_more_info_high_risk',
  epk_flex_onboarding_funds_filter_risk_more_info_high_risk_text:
    'epk_flex_onboarding_funds_filter_risk_more_info_high_risk_text',
  epk_flex_onboarding_funds_filter_funds_step_title:
    'epk_flex_onboarding_funds_filter_funds_step_title',
  epk_flex_onboarding_funds_filter_funds_step_error_text:
    'epk_flex_onboarding_funds_filter_funds_step_error_text',
  epk_flex_onboarding_funds_one_year_return_label:
    'epk_flex_onboarding_funds_one_year_return_label',
  epk_flex_onboarding_funds_risk_label: 'epk_flex_onboarding_funds_risk_label',
  epk_flex_onboarding_funds_annual_cost_label:
    'epk_flex_onboarding_funds_annual_cost_label',
  epk_flex_onboarding_profiles_choose_title:
    'epk_flex_onboarding_profiles_choose_title',
  epk_flex_onboarding_profiles_choose_step_indicator_title:
    'epk_flex_onboarding_profiles_choose_step_indicator_title',
  epk_flex_onboarding_profiles_down_weighting_step_indicator_title:
    'epk_flex_onboarding_profiles_down_weighting_step_indicator_title',
  epk_flex_onboarding_profiles_choose_subtitle:
    'epk_flex_onboarding_profiles_choose_subtitle',
  epk_flex_onboarding_profiles_choose_management_type_modal_trigger:
    'epk_flex_onboarding_profiles_choose_management_type_modal_trigger',
  epk_flex_onboarding_profiles_choose_management_type_modal_title:
    'epk_flex_onboarding_profiles_choose_management_type_modal_title',
  epk_flex_onboarding_profiles_choose_management_type_active_title:
    'epk_flex_onboarding_profiles_choose_management_type_active_title',
  epk_flex_onboarding_profiles_choose_management_type_active_description:
    'epk_flex_onboarding_profiles_choose_management_type_active_description',
  epk_flex_onboarding_profiles_choose_management_type_index_title:
    'epk_flex_onboarding_profiles_choose_management_type_index_title',
  epk_flex_onboarding_profiles_choose_management_type_index_description:
    'epk_flex_onboarding_profiles_choose_management_type_index_description',
  epk_flex_onboarding_funds_no_funds_message:
    'epk_flex_onboarding_funds_no_funds_message',
  epk_flex_onboarding_profiles_list_management_type_index:
    'epk_flex_onboarding_profiles_list_management_type_index',
  epk_flex_onboarding_profiles_list_management_type_active:
    'epk_flex_onboarding_profiles_list_management_type_active',
  epk_flex_onboarding_profiles_list_read_more:
    'epk_flex_onboarding_profiles_list_read_more',
  epk_flex_onboarding_profiles_list_allocation:
    'epk_flex_onboarding_profiles_list_allocation',
  epk_flex_onboarding_profiles_list_allocation_stocks:
    'epk_flex_onboarding_profiles_list_allocation_stocks',
  epk_flex_onboarding_profiles_list_allocation_interest:
    'epk_flex_onboarding_profiles_list_allocation_interest',
  epk_flex_onboarding_risk_profile_error_text:
    'epk_flex_onboarding_risk_profile_error_text',
  epk_flex_onboarding_profiles_list_back_button:
    'epk_flex_onboarding_profiles_list_back_button',
  epk_flex_onboarding_profiles_list_next_button:
    'epk_flex_onboarding_profiles_list_next_button',
  epk_flex_onboarding_funds_filter_funds_select_button:
    'epk_flex_onboarding_funds_filter_funds_select_button',
  epk_flex_onboarding_funds_filter_funds_unselect_button:
    'epk_flex_onboarding_funds_filter_funds_unselect_button',
  epk_flex_onboarding_profiles_down_weighting_title:
    'epk_flex_onboarding_profiles_down_weighting_title',
  epk_flex_onboarding_profiles_down_weighting_standard_radio:
    'epk_flex_onboarding_profiles_down_weighting_standard_radio',
  epk_flex_onboarding_profiles_down_weighting_standard_radio_description:
    'epk_flex_onboarding_profiles_down_weighting_standard_radio_description',
  epk_flex_onboarding_profiles_down_weighting_off_radio:
    'epk_flex_onboarding_profiles_down_weighting_off_radio',
  epk_flex_onboarding_profiles_down_weighting_off_warning:
    'epk_flex_onboarding_profiles_down_weighting_off_warning',
  epk_flex_onboarding_profiles_down_weighting_back_button:
    'epk_flex_onboarding_profiles_down_weighting_back_button',
  epk_flex_onboarding_profiles_down_weighting_next_button:
    'epk_flex_onboarding_profiles_down_weighting_next_button',
  epk_flex_onboarding_funds_filter_selected_funds_accordion_title:
    'epk_flex_onboarding_funds_filter_selected_funds_accordion_title',
  epk_flex_onboarding_funds_sort_alphabetical:
    'epk_flex_onboarding_funds_sort_alphabetical',
  epk_flex_onboarding_funds_sort_risk_score:
    'epk_flex_onboarding_funds_sort_risk_score',
  epk_flex_onboarding_funds_sort_annual_cost:
    'epk_flex_onboarding_funds_sort_annual_cost',
  epk_flex_onboarding_funds_sort_morningstar_rating:
    'epk_flex_onboarding_funds_sort_morningstar_rating',
  epk_flex_onboarding_funds_sort_minimum_amount:
    'epk_flex_onboarding_funds_sort_minimum_amount',
  epk_flex_onboarding_funds_sort_return_last_month:
    'epk_flex_onboarding_funds_sort_return_last_month',
  epk_flex_onboarding_funds_sort_return_this_year:
    'epk_flex_onboarding_funds_sort_return_this_year',
  epk_flex_onboarding_funds_sort_return_one_year:
    'epk_flex_onboarding_funds_sort_return_one_year',
  epk_flex_onboarding_funds_sort_return_n_years:
    'epk_flex_onboarding_funds_sort_return_n_years',
  epk_flex_onboarding_profiles_summary_title:
    'epk_flex_onboarding_profiles_summary_title',
  epk_flex_onboarding_profiles_summary_subtitle:
    'epk_flex_onboarding_profiles_summary_subtitle',
  epk_flex_onboarding_profiles_summary_downweighting_on:
    'epk_flex_onboarding_profiles_summary_downweighting_on',
  epk_flex_onboarding_profiles_summary_downweighting_off:
    'epk_flex_onboarding_profiles_summary_downweighting_off',
  epk_flex_onboarding_funds_filter_distribution_settings_step_title:
    'epk_flex_onboarding_funds_filter_distribution_settings_step_title',
  epk_flex_onboarding_profiles_summary_allocation:
    'epk_flex_onboarding_profiles_summary_allocation',
  epk_flex_onboarding_profiles_summary_recommendation:
    'epk_flex_onboarding_profiles_summary_recommendation',
  epk_flex_onboarding_profiles_summary_higher_risk_warning:
    'epk_flex_onboarding_profiles_summary_higher_risk_warning',
  epk_flex_onboarding_profiles_summary_change_investment_choice_button:
    'epk_flex_onboarding_profiles_summary_change_investment_choice_button',
  epk_flex_onboarding_profiles_summary_cost_title:
    'epk_flex_onboarding_profiles_summary_cost_title',
  epk_flex_onboarding_profiles_summary_cost_description:
    'epk_flex_onboarding_profiles_summary_cost_description',
  epk_flex_onboarding_funds_filter_distribution_settings_step_header:
    'epk_flex_onboarding_funds_filter_distribution_settings_step_header',
  epk_flex_onboarding_profiles_summary_cost_info:
    'epk_flex_onboarding_profiles_summary_cost_info',
  epk_flex_onboarding_funds_filter_distribution_settings_step_total_percentage:
    'epk_flex_onboarding_funds_filter_distribution_settings_step_total_percentage',
  epk_flex_onboarding_funds_filter_distribution_settings_step_total_percentage_indicator:
    'epk_flex_onboarding_funds_filter_distribution_settings_step_total_percentage_indicator',
  epk_flex_onboarding_profiles_summary_back_button:
    'epk_flex_onboarding_profiles_summary_back_button',
  epk_flex_onboarding_profiles_summary_next_button:
    'epk_flex_onboarding_profiles_summary_next_button',
  epk_flex_onboarding_funds_filter_distribution_settings_step_distribution_progressbar_title:
    'epk_flex_onboarding_funds_filter_distribution_settings_step_distribution_progressbar_title',
  epk_flex_onboarding_funds_filter_distribution_settings_step_distribution_progressbar_interest_indicator:
    'epk_flex_onboarding_funds_filter_distribution_settings_step_distribution_progressbar_interest_indicator',
  epk_flex_onboarding_funds_filter_distribution_settings_step_distribution_progressbar_equity_indicator:
    'epk_flex_onboarding_funds_filter_distribution_settings_step_distribution_progressbar_equity_indicator',
  epk_flex_onboarding_funds_filter_distribution_settings_step_info_text:
    'epk_flex_onboarding_funds_filter_distribution_settings_step_info_text',
  epk_flex_onboarding_profiles_summary_allocation_interest:
    'epk_flex_onboarding_profiles_summary_allocation_interest',
  epk_flex_onboarding_profiles_summary_allocation_stocks:
    'epk_flex_onboarding_profiles_summary_allocation_stocks',
  epk_flex_onboarding_confirm_choice_title:
    'epk_flex_onboarding_confirm_choice_title',
  epk_flex_onboarding_confirm_choice_key_info_title:
    'epk_flex_onboarding_confirm_choice_key_info_title',
  epk_flex_onboarding_confirm_choice_key_info_description_profile:
    'epk_flex_onboarding_confirm_choice_key_info_description_profile',
  epk_flex_onboarding_confirm_choice_key_info_description_funds:
    'epk_flex_onboarding_confirm_choice_key_info_description_funds',
  epk_flex_onboarding_confirm_choice_key_info_confirmation:
    'epk_flex_onboarding_confirm_choice_key_info_confirmation',
  epk_flex_onboarding_confirm_choice_fact_sheet_confirmation:
    'epk_flex_onboarding_confirm_choice_fact_sheet_confirmation',
  epk_flex_onboarding_confirm_choice_fact_sheet_link:
    'epk_flex_onboarding_confirm_choice_fact_sheet_link',
  epk_flex_onboarding_confirm_choice_terms_confirmation:
    'epk_flex_onboarding_confirm_choice_terms_confirmation',
  epk_flex_onboarding_confirm_choice_terms_confirmation_link:
    'epk_flex_onboarding_confirm_choice_terms_confirmation_link',
  epk_flex_onboarding_confirm_choice_back_button:
    'epk_flex_onboarding_confirm_choice_back_button',
  epk_flex_onboarding_confirm_choice_complete_button:
    'epk_flex_onboarding_confirm_choice_complete_button',
  epk_flex_onboarding_fund_details_select_button:
    'epk_flex_onboarding_fund_details_select_button',
  epk_flex_onboarding_fund_details_unselect_button:
    'epk_flex_onboarding_fund_details_unselect_button',
  epk_flex_onboarding_success_title: 'epk_flex_onboarding_success_title',
  epk_flex_onboarding_success_description_1:
    'epk_flex_onboarding_success_description_1',
  epk_flex_onboarding_success_description_2:
    'epk_flex_onboarding_success_description_2',
  epk_flex_onboarding_success_description_3:
    'epk_flex_onboarding_success_description_3',
  epk_flex_onboarding_success_info: 'epk_flex_onboarding_success_info',
  epk_flex_onboarding_success_back_button:
    'epk_flex_onboarding_success_back_button',
  epk_flex_onboarding_failure_title: 'epk_flex_onboarding_failure_title',
  epk_flex_onboarding_failure_description:
    'epk_flex_onboarding_failure_description',
  epk_flex_onboarding_failure_try_again_button:
    'epk_flex_onboarding_failure_try_again_button',
  epk_flex_onboarding_failure_contact_support_button:
    'epk_flex_onboarding_failure_contact_support_button',
  epk_flex_onboarding_processing: 'epk_flex_onboarding_processing',
  epk_flex_onboarding_filter_profiles_step:
    'epk_flex_onboarding_filter_profiles_step',
  epk_flex_onboarding_filter_profiles_title:
    'epk_flex_onboarding_filter_profiles_title',
  epk_flex_onboarding_filter_profiles_management_types:
    'epk_flex_onboarding_filter_profiles_management_types',
  epk_flex_onboarding_filter_profiles_select_all:
    'epk_flex_onboarding_filter_profiles_select_all',
  epk_flex_onboarding_filter_profiles_index_type:
    'epk_flex_onboarding_filter_profiles_index_type',
  epk_flex_onboarding_filter_profiles_active_type:
    'epk_flex_onboarding_filter_profiles_active_type',
  epk_flex_onboarding_filter_profiles_select:
    'epk_flex_onboarding_filter_profiles_select',
  epk_flex_onboarding_filter_profiles_back_button:
    'epk_flex_onboarding_filter_profiles_back_button',
  epk_flex_onboarding_filter_profiles_filter_button:
    'epk_flex_onboarding_filter_profiles_filter_button',
  epk_flex_onboarding_funds_filter_distribution_settings_step_distribution_progressbar_error_message:
    'epk_flex_onboarding_funds_filter_distribution_settings_step_distribution_progressbar_error_message',
  epk_flex_onboarding_funds_filter_distribution_settings_step_distribution_progressbar_error_reload_button:
    'epk_flex_onboarding_funds_filter_distribution_settings_step_distribution_progressbar_error_reload_button',
  epk_flex_onboarding_funds_filter_funds_step_previous_button:
    'epk_flex_onboarding_funds_filter_funds_step_previous_button',
  epk_flex_onboarding_funds_filter_funds_step_next_button:
    'epk_flex_onboarding_funds_filter_funds_step_next_button',
  epk_flex_onboarding_funds_filter_distribution_settings_step_previous_button:
    'epk_flex_onboarding_funds_filter_distribution_settings_step_previous_button',
  epk_flex_onboarding_funds_filter_distribution_settings_step_next_button:
    'epk_flex_onboarding_funds_filter_distribution_settings_step_next_button',
  epk_flex_onboarding_profiles_list_count:
    'epk_flex_onboarding_profiles_list_count',
  epk_flex_onboarding_profiles_list_filter_button:
    'epk_flex_onboarding_profiles_list_filter_button',
  epk_flex_onboarding_eligibility_step_criteria_group_rule_1:
    'epk_flex_onboarding_eligibility_step_criteria_group_rule_1',
  epk_flex_onboarding_profiles_summary_lower_risk_warning:
    'epk_flex_onboarding_profiles_summary_lower_risk_warning',
  epk_flex_onboarding_eligibility_risk_questionnaire_allocation_proposal_tip_1:
    'epk_flex_onboarding_eligibility_risk_questionnaire_allocation_proposal_tip_1',
  epk_flex_onboarding_eligibility_risk_questionnaire_allocation_proposal_tip_2:
    'epk_flex_onboarding_eligibility_risk_questionnaire_allocation_proposal_tip_2',
  epk_flex_onboarding_eligibility_step_costs_info_2:
    'epk_flex_onboarding_eligibility_step_costs_info_2',
  epk_flex_onboarding_eligibility_step_explanation_info_2:
    'epk_flex_onboarding_eligibility_step_explanation_info_2',
  epk_flex_onboarding_funds_distribution_summary_step_header:
    'epk_flex_onboarding_funds_distribution_summary_step_header',
  epk_flex_onboarding_funds_distribution_summary_step_sub_header:
    'epk_flex_onboarding_funds_distribution_summary_step_sub_header',
  epk_flex_onboarding_funds_distribution_summary_step_list_header:
    'epk_flex_onboarding_funds_distribution_summary_step_list_header',
  epk_flex_onboarding_funds_distribution_summary_step_change_button:
    'epk_flex_onboarding_funds_distribution_summary_step_change_button',
  epk_flex_onboarding_funds_distribution_summary_step_risk_bar_title:
    'epk_flex_onboarding_funds_distribution_summary_step_risk_bar_title',
  epk_flex_onboarding_funds_distribution_summary_step_risk_bar_interest_label:
    'epk_flex_onboarding_funds_distribution_summary_step_risk_bar_interest_label',
  epk_flex_onboarding_funds_distribution_summary_step_risk_bar_stock_label:
    'epk_flex_onboarding_funds_distribution_summary_step_risk_bar_stock_label',
  epk_flex_onboarding_funds_distribution_summary_step_recomended_bar_title:
    'epk_flex_onboarding_funds_distribution_summary_step_recomended_bar_title',
  epk_flex_onboarding_funds_distribution_summary_step_recomended_bar_interest_label:
    'epk_flex_onboarding_funds_distribution_summary_step_recomended_bar_interest_label',
  epk_flex_onboarding_funds_distribution_summary_step_recomended_bar_stock_label:
    'epk_flex_onboarding_funds_distribution_summary_step_recomended_bar_stock_label',
  epk_flex_onboarding_funds_distribution_summary_step_higher_risk_warning:
    'epk_flex_onboarding_funds_distribution_summary_step_higher_risk_warning',
  epk_flex_onboarding_funds_distribution_summary_step_update_distribution_button:
    'epk_flex_onboarding_funds_distribution_summary_step_update_distribution_button',
  epk_flex_onboarding_funds_distribution_summary_step_info_text:
    'epk_flex_onboarding_funds_distribution_summary_step_info_text',
  epk_flex_onboarding_funds_distribution_summary_step_annual_cost_section_header:
    'epk_flex_onboarding_funds_distribution_summary_step_annual_cost_section_header',
  epk_flex_onboarding_funds_distribution_summary_step_annual_cost_title:
    'epk_flex_onboarding_funds_distribution_summary_step_annual_cost_title',
  epk_flex_onboarding_funds_distribution_summary_step_annual_cost_text:
    'epk_flex_onboarding_funds_distribution_summary_step_annual_cost_text',
  epk_flex_onboarding_funds_filter_distribution_summary_step_previous_button:
    'epk_flex_onboarding_funds_filter_distribution_summary_step_previous_button',
  epk_flex_onboarding_funds_filter_distribution_summary_step_next_button:
    'epk_flex_onboarding_funds_filter_distribution_summary_step_next_button',
  epk_flex_onboarding_profiles_choose_management_type_previous_label:
    'epk_flex_onboarding_profiles_choose_management_type_previous_label',
  epk_flex_onboarding_profiles_choose_management_type_next_label:
    'epk_flex_onboarding_profiles_choose_management_type_next_label',
  epk_flex_onboarding_distribution_settings_step_error_text:
    'epk_flex_onboarding_distribution_settings_step_error_text',
  epk_flex_onboarding_eligibility_step_costs_product_fund_name:
    'epk_flex_onboarding_eligibility_step_costs_product_fund_name',
  epk_flex_onboarding_eligibility_step_costs_product_profiles_name:
    'epk_flex_onboarding_eligibility_step_costs_product_profiles_name',
  epk_flex_onboarding_eligibility_step_costs_bottom_info_non_dnb:
    'epk_flex_onboarding_eligibility_step_costs_bottom_info_non_dnb',
  epk_flex_onboarding_eligibility_error_text:
    'epk_flex_onboarding_eligibility_error_text',
  epk_flex_onboarding_eligibility_risk_questionnaire_step_three_risk_profile_safe_title:
    'epk_flex_onboarding_eligibility_risk_questionnaire_step_three_risk_profile_safe_title',
  epk_flex_onboarding_eligibility_risk_questionnaire_step_three_risk_profile_safe_text:
    'epk_flex_onboarding_eligibility_risk_questionnaire_step_three_risk_profile_safe_text',
  epk_flex_onboarding_eligibility_risk_questionnaire_step_three_risk_profile_stable_title:
    'epk_flex_onboarding_eligibility_risk_questionnaire_step_three_risk_profile_stable_title',
  epk_flex_onboarding_eligibility_risk_questionnaire_step_three_risk_profile_stable_text:
    'epk_flex_onboarding_eligibility_risk_questionnaire_step_three_risk_profile_stable_text',
  epk_flex_onboarding_eligibility_risk_questionnaire_step_three_risk_profile_balanced_title:
    'epk_flex_onboarding_eligibility_risk_questionnaire_step_three_risk_profile_balanced_title',
  epk_flex_onboarding_eligibility_risk_questionnaire_step_three_risk_profile_balanced_text:
    'epk_flex_onboarding_eligibility_risk_questionnaire_step_three_risk_profile_balanced_text',
  epk_flex_onboarding_eligibility_risk_questionnaire_step_three_risk_profile_dynamic_title:
    'epk_flex_onboarding_eligibility_risk_questionnaire_step_three_risk_profile_dynamic_title',
  epk_flex_onboarding_eligibility_risk_questionnaire_step_three_risk_profile_dynamic_text:
    'epk_flex_onboarding_eligibility_risk_questionnaire_step_three_risk_profile_dynamic_text',
  epk_flex_onboarding_eligibility_risk_questionnaire_step_three_risk_profile_bar_title:
    'epk_flex_onboarding_eligibility_risk_questionnaire_step_three_risk_profile_bar_title',
  epk_flex_onboarding_funds_chart_last_updated_label:
    'epk_flex_onboarding_funds_chart_last_updated_label',
  epk_flex_onboarding_funds_filter_fund_type_item_action_fund:
    'epk_flex_onboarding_funds_filter_fund_type_item_action_fund',
  epk_flex_onboarding_funds_filter_fund_type_item_interest_fund:
    'epk_flex_onboarding_funds_filter_fund_type_item_interest_fund',
  epk_flex_onboarding_funds_filter_fund_type_item_index_fund:
    'epk_flex_onboarding_funds_filter_fund_type_item_index_fund',
  epk_flex_onboarding_funds_filter_fund_type_item_environmental_fund:
    'epk_flex_onboarding_funds_filter_fund_type_item_environmental_fund',
  epk_flex_onboarding_funds_filter_fund_type_item_combination_fund:
    'epk_flex_onboarding_funds_filter_fund_type_item_combination_fund',
  epk_flex_onboarding_funds_filter_select_fund_type_step_title:
    'epk_flex_onboarding_funds_filter_select_fund_type_step_title',
  epk_flex_onboarding_funds_filter_select_fund_type_filter_title:
    'epk_flex_onboarding_funds_filter_select_fund_type_filter_title',
  epk_flex_onboarding_funds_filter_select_fund_type_filter_skip_button:
    'epk_flex_onboarding_funds_filter_select_fund_type_filter_skip_button',
  epk_flex_onboarding_funds_filter_funds_item_performance_fee_info:
    'epk_flex_onboarding_funds_filter_funds_item_performance_fee_info',
  epk_flex_onboarding_profiles_down_weighting_standard_radio_tag:
    'epk_flex_onboarding_profiles_down_weighting_standard_radio_tag',
  epk_flex_onboarding_funds_with_performance_fee_confirm_choice_key_info_confirmation:
    'epk_flex_onboarding_funds_with_performance_fee_confirm_choice_key_info_confirmation',
  epk_flex_onboarding_funds_distribution_summary_step_performance_fee_title:
    'epk_flex_onboarding_funds_distribution_summary_step_performance_fee_title',
  epk_flex_onboarding_funds_distribution_summary_step_performance_fee_text:
    'epk_flex_onboarding_funds_distribution_summary_step_performance_fee_text',
  epk_flex_onboarding_funds_distribution_summary_step_performance_fee_tag:
    'epk_flex_onboarding_funds_distribution_summary_step_performance_fee_tag',
  epk_flex_onboarding_eligibility_risk_questionnaire_step_three_risk_profile_link:
    'epk_flex_onboarding_eligibility_risk_questionnaire_step_three_risk_profile_link',
  epk_flex_onboarding_funds_details_error_text:
    'epk_flex_onboarding_funds_details_error_text',
  epk_flex_onboarding_profiles_list_filter_active:
    'epk_flex_onboarding_profiles_list_filter_active',
  epk_flex_onboarding_funds_filter_funds_step_funds_amount:
    'epk_flex_onboarding_funds_filter_funds_step_funds_amount',
  epk_flex_onboarding_funds_filter_funds_step_filter_button:
    'epk_flex_onboarding_funds_filter_funds_step_filter_button',
  epk_flex_onboarding_funds_filter_funds_step_filter_active_filters:
    'epk_flex_onboarding_funds_filter_funds_step_filter_active_filters',
  epk_flex_onboarding_profiles_list_filters_label:
    'epk_flex_onboarding_profiles_list_filters_label',
  epk_flex_onboarding_funds_filter_funds_step_filter_active_filters_label:
    'epk_flex_onboarding_funds_filter_funds_step_filter_active_filters_label',
  epk_flex_onboarding_funds_historic_price_error_text:
    'epk_flex_onboarding_funds_historic_price_error_text',
  epk_flex_onboarding_profiles_down_weighting_standard_radio_tag_label:
    'epk_flex_onboarding_profiles_down_weighting_standard_radio_tag_label',
  epk_flex_onboarding_funds_distribution_summary_step_performance_fee_tag_label:
    'epk_flex_onboarding_funds_distribution_summary_step_performance_fee_tag_label',
  epk_flex_onboarding_funds_distribution_settings_step_warning_message:
    'epk_flex_onboarding_funds_distribution_settings_step_warning_message',
  epk_flex_onboarding_funds_filter_funds_step_empty_state:
    'epk_flex_onboarding_funds_filter_funds_step_empty_state',
  epk_flex_onboarding_funds_filter_funds_step_empty_state_button:
    'epk_flex_onboarding_funds_filter_funds_step_empty_state_button',
  epk_flex_onboarding_profiles_list_yearly_cost:
    'epk_flex_onboarding_profiles_list_yearly_cost',
  epk_flex_onboarding_profile_options_back_button:
    'epk_flex_onboarding_profile_options_back_button',
  epk_flex_onboarding_profile_options_next_button:
    'epk_flex_onboarding_profile_options_next_button',
  epk_flex_onboarding_funds_distribution_summary_step_lower_risk_warning:
    'epk_flex_onboarding_funds_distribution_summary_step_lower_risk_warning',
  epk_flex_onboarding_funds_details_annual_fee_explanation_text:
    'epk_flex_onboarding_funds_details_annual_fee_explanation_text',
  epk_flex_onboarding_funds_filter_select_fund_region_filter_skip_button:
    'epk_flex_onboarding_funds_filter_select_fund_region_filter_skip_button',
  epk_flex_onboarding_funds_filter_select_fund_risk_filter_skip_button:
    'epk_flex_onboarding_funds_filter_select_fund_risk_filter_skip_button',
  epk_flex_onboarding_profiles_summary_downweighting_off_warning:
    'epk_flex_onboarding_profiles_summary_downweighting_off_warning',
  epk_flex_onboarding_confirm_choice_fact_info_title:
    'epk_flex_onboarding_confirm_choice_fact_info_title',
  epk_flex_onboarding_confirm_choice_terms_info_title:
    'epk_flex_onboarding_confirm_choice_terms_info_title',
  epk_flex_onboarding_profile_options_description:
    'epk_flex_onboarding_profile_options_description',
  epk_flex_onboarding_eligibility_check_eligible_description:
    'epk_flex_onboarding_eligibility_check_eligible_description',
  epk_flex_onboarding_eligibility_check_not_eligible_description_age:
    'epk_flex_onboarding_eligibility_check_not_eligible_description_age',
  epk_flex_onboarding_eligibility_check_not_eligible_description_already_exist:
    'epk_flex_onboarding_eligibility_check_not_eligible_description_already_exist',
  epk_flex_onboarding_eligibility_check_not_eligible_description_no_pension_account:
    'epk_flex_onboarding_eligibility_check_not_eligible_description_no_pension_account',
  epk_flex_onboarding_eligibility_check_not_eligible_description_no_personal_info:
    'epk_flex_onboarding_eligibility_check_not_eligible_description_no_personal_info',
  epk_flex_onboarding_eligibility_check_ineligible_text:
    'epk_flex_onboarding_eligibility_check_ineligible_text',
  epk_flex_onboarding_funds_distribution_summary_step_cost_explanation_text:
    'epk_flex_onboarding_funds_distribution_summary_step_cost_explanation_text',
  epk_flex_onboarding_funds_distribution_summary_step_cost_explanation_show_more_button:
    'epk_flex_onboarding_funds_distribution_summary_step_cost_explanation_show_more_button',
  epk_flex_onboarding_funds_distribution_summary_step_cost_explanation_show_less_button:
    'epk_flex_onboarding_funds_distribution_summary_step_cost_explanation_show_less_button',
  epk_flex_onboarding_profiles_summary_cost_explanation_text:
    'epk_flex_onboarding_profiles_summary_cost_explanation_text',
  epk_flex_onboarding_profiles_summary_cost_explanation_show_more_button:
    'epk_flex_onboarding_profiles_summary_cost_explanation_show_more_button',
  epk_flex_onboarding_profiles_summary_cost_explanation_show_less_button:
    'epk_flex_onboarding_profiles_summary_cost_explanation_show_less_button',
  epk_flex_onboarding_fund_details_key_information_link_text:
    'epk_flex_onboarding_fund_details_key_information_link_text',
};

Object.freeze(translationKeys);

export default translationKeys;
